/** React Query key for the limits envelope — shared so writes elsewhere
 *  (e.g. a future restriction banner) can invalidate it. */
export const LIMITS_QUERY_KEY = ['me', 'responsible-gambling-limits'] as const;
